// @owners { team: patients }
import { useEffect, useRef } from 'react';
import { getOrderDate } from '~shared/features/checkout/selectors/getOrder';
import { getIsEditingExistingOrder } from '~shared/features/ui/selectors/getCart';
import { useAnalytics, usePrevious } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';
import { useSelectorShared } from '~shared/store';

export const useTrackDateSelection = () => {
  const { trackEvent } = useAnalytics();
  const orderDate = useSelectorShared(getOrderDate);
  const isEditingOrder = useSelectorShared(getIsEditingExistingOrder);
  const originalDate = useRef(orderDate);
  const previousDate = usePrevious(orderDate);

  // 🐾 track when the date is auto-selected initially
  useEffect(() => {
    if (!originalDate.current) return;
    trackEvent({
      event: EVENTS.CHECKOUT__DATE_SELECTED,
      params: {
        'auto-selected': true,
        date: originalDate.current,
        origin: isEditingOrder ? 'edit delivery' : 'checkout',
      },
    });
  }, [isEditingOrder, trackEvent]);

  // 🐾 track when the patient selects a different date
  useEffect(() => {
    if (previousDate && previousDate !== orderDate) {
      trackEvent({
        event: EVENTS.CHECKOUT__DATE_SELECTED,
        params: {
          'auto-selected': false,
          date: orderDate,
          origin: isEditingOrder ? 'edit delivery' : 'checkout',
        },
      });
    }
  }, [isEditingOrder, previousDate, orderDate, trackEvent]);
};
